@if (showAlert) {
    <div class="alert alert-warning text-center clickable" (click)="subscribeToPushNotifications()">
        {{ 'ALERTS.SUBSCRIBE_TO_PUSH_NOTIFICATIONS' | translate }}
        <button type="button" (click)="dismiss($event)" class="btn-close float-end"></button>
    </div>
}
